import { object, string } from "yup";
import { DISCAPACIDADES } from "../../../../constants/contexts";

export const FormikInitialValues = {
	valor: "",
	contexto: DISCAPACIDADES,
}

export const FormikValidationSchema = object().shape({
	valor: string()
		.min(3, ({ min }) => `La discapacidad debe tener al menos ${min} caracteres.`)
		.max(200, ({ max }) => `La discapacidad debe tener a lo más ${max} caracteres.`)
		.required("La discapacidad es requerida."),
});